import { GridApi, GridOptions, IServerSideDatasource, IServerSideGetRowsParams } from '@ag-grid-community/core';
import { Component, Input, OnInit,OnDestroy } from '@angular/core';
import { LoadingCellRendererComponent } from "src/app/ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { Subject } from 'rxjs';
import { FbmOrdersPackedCountCellRendererComponent } from 'src/app/ag-grid-components/fbm-orders-packed-count-cell-renderer/fbm-orders-packed-count-cell-renderer.component';
import { SkuCellRendererComponent } from 'src/app/ag-grid-components/sku-cell-renderer/sku-cell-renderer.component';
import { ShipOrderProduct } from 'src/app/models/fbmOrders.model';

@Component({
  selector: 'app-fbm-productdetails',
  templateUrl: './fbm-productdetails.component.html',
  styleUrls: ['./fbm-productdetails.component.scss']
})
export class FbmProductdetailsComponent implements OnInit,OnDestroy {

  productGridApi: GridApi;
  private _destroy:Subject<void>=new Subject<void>()
  
  constructor() { }

  ngOnInit(): void { 
    
  }

  private _productList: Array<ShipOrderProduct>;
  @Input() get productList(): Array<ShipOrderProduct> {
    return this._productList;
  }

  set productList(value) {
    this._productList = value;
    if (value) {
      this.productGridApi?.setGridOption("serverSideDatasource", this.productDataSource);
    }
  }

  refresh(){
    this.productGridApi?.refreshServerSide();
  }

  private components = {
    loadingCellRenderer: LoadingCellRendererComponent,
    skuCellRendererComponent: SkuCellRendererComponent,
    fbmOrdersPackedCountCellRendererComponent: FbmOrdersPackedCountCellRendererComponent
  };

  productGridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    blockLoadDebounceMillis: 1,
    suppressCopyRowsToClipboard: true,
    defaultColDef: {
      menuTabs: ["filterMenuTab"],
      sortable:false
    },
    components: this.components,
    rowHeight: 60,
    headerHeight: 30,
    loadingCellRenderer: "loadingCellRenderer",
    cacheBlockSize: 100,
    pivotPanelShow: "onlyWhenPivoting",
    rowBuffer: 50,
    enableCellChangeFlash: true,
    onGridReady: (e) => {
      this.productGridApi = e.api;
      this.productGridApi.setGridOption("serverSideDatasource", this.productDataSource);
      this.productGridApi.sizeColumnsToFit();
    }
  };


  productColumnDefs = [
    {
      field: "Title",
      headerName: "Product Information",
      cellRenderer: "skuCellRendererComponent",
      width: 150,
    },
    {
      field: "Qty",
      headerName: "Qty",
      width: 50,
      valueGetter: (params) => {
        return (Number(params.data.Qty) || 0).toLocaleString('en');
      },
    },
    {
      field: "Packed",
      headerName: "Packed",
      cellRenderer: "fbmOrdersPackedCountCellRendererComponent",
      cellRendererParams: (params: any) => params.data.amount = params.data.Packed,
      width: 50,
    }
  ];

  productDataSource: IServerSideDatasource = {
    getRows: (params: IServerSideGetRowsParams) => {
      if (this._productList && this._productList.length==0 ) {
        this.productGridApi.showNoRowsOverlay();
      }else{
        this.productGridApi.hideOverlay();
      }
      const details = this._productList?.map((details: any) => {
        var keys = Object.keys(details);
        const response: any = keys.reduce((obj, current) => {
          const keyName = current.charAt(0).toUpperCase() + current.slice(1)
          obj[keyName] = details[current];
          return obj;
        }, {});
        return response;
      });
      params.success({
        rowData: details,
        rowCount: details?.length ?? 0
      });
    },
  };

  ngOnDestroy():void{
    this._destroy.next();
    this._destroy.unsubscribe();
  }
}
